import React from 'react';
import { useLocation } from 'react-router-dom';
import { seoFor } from '../lib/seo';
import { usePublicData } from '../lib/publicData';
import { siteOrigin } from '../lib/siteOrigin';
import api from '../lib/api';

export const PageSEO = () => {
  const { pathname, search } = useLocation();
  const data = usePublicData();
  React.useEffect(() => {
    let active = true;
    const isShop = pathname.startsWith('/fiches-lumiere');
    const applySEO = currentData => {
      if (!active) return;
      const seo = seoFor(isShop ? pathname + search : pathname, currentData);
      const origin = siteOrigin(process.env.REACT_APP_SITE_URL);
      document.title = seo.title;
      const tags = [['name','description',seo.description],['property','og:title',seo.title],['property','og:description',seo.description],
        ['property','og:image',new URL(seo.image,origin).href],['property','og:url',new URL(seo.canonical,origin).href],
        ['property','og:locale',seo.locale || 'fr_CH'],
        ['name','twitter:title',seo.title],['name','twitter:description',seo.description],['name','twitter:image',new URL(seo.image,origin).href],
        ['name','robots',seo.public?'index,follow':'noindex,follow']];
      tags.forEach(([attribute,key,value]) => {
        let element = document.head.querySelector(`meta[${attribute}="${key}"]`);
        if (!element) {element=document.createElement('meta');element.setAttribute(attribute,key);document.head.appendChild(element);}
        element.setAttribute('content',value);
      });
      let canonical=document.head.querySelector('link[rel="canonical"]');
      if(!canonical){canonical=document.createElement('link');canonical.rel='canonical';document.head.appendChild(canonical);}
      canonical.href=new URL(seo.canonical,origin).href;
    };
    applySEO(data);
    if (isShop) {
      api.get('/pdf-shop/catalog').then(({data: catalog}) => applySEO({...data, pdf_shop_catalog: catalog}))
        .catch(() => applySEO({...data, pdf_shop_catalog: {...data.pdf_shop_catalog, checkout_enabled: false}}));
    }
    return () => { active = false; };
  },[pathname,search,data]);
  return null;
};